import { render, staticRenderFns } from "./WarehouseIndex.vue?vue&type=template&id=46726d81&scoped=true&"
import script from "./WarehouseIndex.vue?vue&type=script&lang=js&"
export * from "./WarehouseIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46726d81",
  null
  
)

export default component.exports